import { render, staticRenderFns } from "./exportCom.vue?vue&type=template&id=0b6f1ba4&scoped=true"
import script from "./exportCom.vue?vue&type=script&lang=js"
export * from "./exportCom.vue?vue&type=script&lang=js"
import style0 from "./exportCom.vue?vue&type=style&index=0&id=0b6f1ba4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6f1ba4",
  null
  
)

export default component.exports